import React from "react";
import { motion } from "framer-motion";

const IMG1 = "/amme/interior-2.jpg";
const IMG2 = "/amme/deck-view.jpg";

export const Setting = ({ t }) => {
  return (
    <section
      data-testid="setting-section"
      className="relative bg-[#cececc] py-32 md:py-48 overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-end">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-6"
          >
            <div className="aspect-[4/5] w-full overflow-hidden bg-stone-300">
              <img
                src={IMG1}
                alt="Infinity pool in the jungle"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.2, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-6"
          >
            <p className="text-[11px] uppercase tracking-[0.4em] text-stone-500 mb-6">
              — {t.setting.label}
            </p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] text-stone-900 tracking-tight">
              {t.setting.heading}{" "}
              <span className="italic text-[#3d3d3b]">
                {t.setting.headingItalic}
              </span>
            </h2>
            <p className="mt-8 md:mt-10 text-stone-700 text-base md:text-lg font-light leading-[1.8] max-w-lg">
              {t.setting.body}
            </p>

            <ul className="mt-10 md:mt-12 space-y-4">
              {t.setting.features.map((f, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: 0.1 * i }}
                  className="flex items-center gap-4 text-stone-800 text-sm md:text-base font-light border-b border-stone-300/70 pb-4"
                >
                  <span className="text-[#3d3d3b] font-serif text-lg">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span>{f}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="mt-20 md:mt-32 grid grid-cols-1 md:grid-cols-12 gap-8 items-center"
        >
          <div className="md:col-span-5 md:col-start-2 md:pr-8">
            <p className="font-serif italic text-2xl md:text-3xl lg:text-4xl leading-[1.3] text-stone-800">
              &ldquo;{t.setting.quote}&rdquo;
            </p>
          </div>
          <div className="md:col-span-6">
            <div className="aspect-[16/10] w-full overflow-hidden bg-stone-300">
              <img
                src={IMG2}
                alt="Jungle villa"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
